var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTlCardBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 268,
    viewBox: "0 0 211 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 -7.5C211 66.23 151.23 126 77.5 126C3.76999 126 -56 66.23 -56 -7.5C-56 -81.23 3.76999 -141 77.5 -141C151.23 -141 211 -81.23 211 -7.5Z",
    fill: "#D0FFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93 137C93 209.349 34.3493 268 -38 268C-110.349 268 -169 209.349 -169 137C-169 64.6507 -110.349 6 -38 6C34.3493 6 93 64.6507 93 137Z",
    fill: "#A7FFAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 137C93 209.349 34.3493 268 -38 268C-110.349 268 -169 209.349 -169 137C-169 64.6507 -110.349 6 -38 6C34.3493 6 93 64.6507 93 137Z",
    fill: "#A7FFAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93 137C93 209.349 34.3493 268 -38 268C-110.349 268 -169 209.349 -169 137C-169 64.6507 -110.349 6 -38 6C34.3493 6 93 64.6507 93 137Z",
    fill: "#A7FFAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93 137C93 209.349 34.3493 268 -38 268C-110.349 268 -169 209.349 -169 137C-169 64.6507 -110.349 6 -38 6C34.3493 6 93 64.6507 93 137Z",
    fill: "#A7FFAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93 137C93 209.349 34.3493 268 -38 268C-110.349 268 -169 209.349 -169 137C-169 64.6507 -110.349 6 -38 6C34.3493 6 93 64.6507 93 137Z",
    fill: "#A7FFAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlCardBg);
export default __webpack_public_path__ + "static/media/tl-card-bg.9ebd0d3ec8083880f041478a03d0510d.svg";
export { ForwardRef as ReactComponent };